import { createFileRoute } from "@tanstack/react-router";
import { usePublicConfig } from "@/api/queries/config";
import { ArticleTeaser } from "@/components/flirt-tipps/ArticleTeaser";
import { flirtArticles } from "@/components/flirt-tipps/articles";
import { usePageMeta } from "@/hooks/use-page-meta";

export const Route = createFileRoute("/_app/flirt-tipps/")({
	component: FlirtTippsPage,
});

function FlirtTippsPage() {
	const { data: config } = usePublicConfig();

	usePageMeta({
		title: config ? `Flirt-Tipps - ${config.seo.defaultTitle}` : undefined,
	});

	return (
		<div className="max-w-3xl mx-auto space-y-6">
			<h1 className="text-2xl font-bold text-text">Flirt-Tipps</h1>
			<p className="text-text-secondary">Tipps und Tricks für erfolgreiches Online-Dating.</p>
			<div className="space-y-4">
				{flirtArticles.map((article) => (
					<ArticleTeaser key={article.slug} article={article} />
				))}
			</div>
		</div>
	);
}
